module.exports = __webpack_public_path__ + "static/media/screens.3786de0a.svg";